import { createPortal } from 'react-dom';

export interface ConfirmModalAction {
  label: string;
  onClick: () => void;
  variant?: 'red' | 'blue' | 'gray';
}

interface ConfirmModalProps {
  title: string;
  message: string;
  actions: ConfirmModalAction[];
  onDismiss: () => void;
}

// Rendered via a portal so it escapes Leaflet's transformed panes (which would otherwise trap position:fixed).
const ConfirmModal: React.FC<ConfirmModalProps> = ({ title, message, actions, onDismiss }) => {
  return createPortal(
    <div
      id="confirm-modal"
      className="fixed inset-0 z-[2147483647] flex items-center justify-center p-4"
      role="alertdialog"
      aria-modal="true"
      aria-label={title}
    >
      <div
        id="confirm-modal-overlay"
        className="absolute inset-0 bg-black/50"
        onClick={onDismiss}
        aria-hidden="true"
      />
      <div
        id="confirm-modal-panel"
        className="relative w-[min(92vw,340px)]"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="confirm-modal-title" className="mb-3 text-center text-lg font-bold text-slate-100">
          {title}
        </h2>
        <p id="confirm-modal-message" className="mb-5 whitespace-pre-line text-center text-sm text-slate-200">
          {message}
        </p>
        <div className="flex flex-col gap-2">
          {actions.map((action) => (
            <button
              key={action.label}
              type="button"
              onClick={action.onClick}
              className={`btn-action btn-${action.variant ?? 'blue'}`}
            >
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ConfirmModal;
